<template>
  <v-app class="bgLightGreen" id="inspire">
    <Header back header-text="lng_charts"></Header>
    <v-container fluid v-if="!helpDialog">
      <v-flex xs12 sm6 md8 d-flex class="chart-hr">
        <v-flex xs12 sm6 md4>
          <v-select
            :items="hours"
            @change="changeHours()"
            v-model="selectedHours"
            v-if="date === currentDate"
          >
            <template v-slot:selection="{ item, index }">
              <span>{{ item }} {{ "lng_hours" | translate }}</span>
            </template>
            <template v-slot:item="{ item, index }">
              <span>{{ item }} {{ "lng_hours" | translate }}</span>
            </template>
          </v-select>
          <v-text-field v-else value="24 h" readonly disabled></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="date"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              :min="getPreviousDate"
              :max="currentDate"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="changeDate">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
      </v-flex>
      <div
        v-if="chartsPopulated"
        class="row-graph layout-row layout-align-space-around-stretch"
      >
        <Chart
          v-for="(chart, index) in chartsData"
          :key="index"
          :chart-name="chartsTitles[index]"
          :chart-data="chart"
        ></Chart>
      </div>
    </v-container>
    <help-dialog
      dialog-title="Data"
      help-text="No Data Available For Charts, Redirect To MainPage"
      :openDialog="helpDialog"
      :closeDialog="closeDataDialog"
    ></help-dialog>
  </v-app>
</template>
<style>
.chart-hr .v-input {
  margin: 20px 0 26px;
  padding-left: 20px;
}
.chart-block {
  margin-bottom: 20px;
}
</style>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import Chart from "./../components/charts/Chart";
import HelpDialog from "./../components/HelpDialog";
import GlobalService from "../services/global-service";
import router from "./../router.js";
import * as ChartsOptions from "./../common/ChartsOptions";

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      currentDate: new Date().toISOString().substr(0, 10),
      menu: false,
      chartsPopulated: false,
      //data for charts plotting
      chartsData: [],
      //hours options to select hours from
      hours: ChartsOptions.chartsHours,
      //charts titles for all charts
      chartsTitles: ChartsOptions.chartsTitles,
      //set hours to get data if present in local storage else 3 by default
      selectedHours: localStorage.getItem("hours")
        ? localStorage.getItem("hours")
        : ChartsOptions.chartsHours[1],
      helpDialog: false
    };
  },
  computed: {
    //getter to get user user token from user
    ...mapGetters("user", ["getUser"]),
    getPreviousDate() {
      let currDay = new Date();
      let prevDay = currDay.setDate(currDay.getDate() - 29);
      return new Date(prevDay).toISOString().substr(0, 10);
    }
  },
  components: {
    Chart,
    Header,
    HelpDialog
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  async created() {
    this.initData();
    await this.changeHours();
  },
  methods: {
    changeDate() {
      this.$refs.menu.save(this.date);
      this.changeHours();
    },
    // change hours for fetching data according to selected hours
    async changeHours() {
      this.$store.commit("global/setLoading", true);
      this.chartsPopulated = false;
      this.initData();
      await this.fetchChartsData();
      localStorage.setItem("hours", this.selectedHours);
      this.$store.commit("global/setLoading", false);
      this.chartsPopulated = true;
    },
    // api call to fetch raw data
    async fetchChartsData() {
      let rawData;
      try {
        rawData = await GlobalService.getChartsData(
          this.date === this.currentDate ? this.selectedHours : 24,
          this.date === this.currentDate ? "today" : this.date,
          this.getUser.token
        );
        if (rawData.length > 0) this.cleanData(rawData);
        else this.helpDialog = true;
      } catch (e) {
        this.helpDialog = true;
      }
    },
    //initializes array with empty arrays of data
    initData() {
      this.chartsData = [];
      this.chartsTitles.forEach(() => {
        this.chartsData.push([]);
      });
    },
    // raw data converted to charts data for plotting
    cleanData(rawData) {
      rawData.forEach(element => {
        this.chartsData[element.chartidx].push(element);
      });
    },
    // close update field's slider range dialog
    closeDataDialog() {
      router.push("/");
      this.helpDialog = false;
    }
  }
};
</script>
